import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class StallEnquiryApi {
  getStallEnquiriesByExpo = async (expoId, search = "", page, limit = 10000, source = "") => {
    try {
      const response = await api.get(`/client/enquiries/stall`, {
        params: { expoId, search, page, limit, source },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveStallEnquiry = async (data) => {
    try {
      const response = await api.post("/stall-enquiry", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Submit Stall Enquiry";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateStallEnquiry = async (id, data) => {
    try {
      const response = await api.put(`/stall-enquiry/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Update Stall Enquiry";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateStallEnquiryStatus = async (id, data) => {
    try {
      const response = await api.patch(`/stall-enquiry/status/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Update Status";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteStallEnquiry = async (id) => {
    try {
      const response = await api.delete(`/stall-enquiry/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Delete Stall Enquiry";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getStallBookedList = async (params) => {
    try {
      const response = await api.get("/stall-enquiry/booked-list", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Fetch Booked Stalls";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  downloadStallBookedExcel = async (params) => {
    try {
      const response = await api.get("/stall-enquiry/booked-list", {
        params: { ...params, format: "excel" },
        responseType: "blob",
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Download Excel";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getTodayFollowups = async (params) => {
    try {
      const response = await api.get("/client/followups/today", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Fetch Today Followups";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  downloadEnquirySample = async (type = "stall") => {
    try {
      const response = await api.get("/client/enquiries/sample-download", {
        params: { type },
        responseType: "blob",
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Download Sample Excel";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  bulkUploadEnquiries = async (formData) => {
    try {
      const response = await api.post("/client/enquiries/bulk-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Upload Enquiries";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const stallEnquiryApi = new StallEnquiryApi();
export default stallEnquiryApi;

export const {
  getStallEnquiriesByExpo,
  saveStallEnquiry,
  updateStallEnquiry,
  updateStallEnquiryStatus,
  deleteStallEnquiry,
  getStallBookedList,
  downloadStallBookedExcel,
  getTodayFollowups,
  downloadEnquirySample,
  bulkUploadEnquiries,
} = stallEnquiryApi;
